import { render, staticRenderFns } from "./LoginSocialComponent.vue?vue&type=template&id=35cc0bd6&"
import script from "./LoginSocialComponent.vue?vue&type=script&lang=js&"
export * from "./LoginSocialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports